import { render } from "./DeleteView.vue?vue&type=template&id=36fb3634&ts=true"
import script from "./DeleteView.vue?vue&type=script&lang=ts"
export * from "./DeleteView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__